/**
 * Course Resources Service for Students
 * Fetches files with inheritance from parent levels
 */
import axios from 'axios';
import { getConfig } from '@/config/Constants';
import type { StudentFileListResponse } from '@/types/courseFile.types';

class CourseResourcesService {
  private getAuthHeaders() {
    const token = localStorage.getItem('access_token');
    return {
      Authorization: `Bearer ${token}`,
    };
  }

  /**
   * Get all files for a topic (including inherited parent-level files)
   */
  async getTopicFiles(courseId: string, topicId: string): Promise<StudentFileListResponse> {
    const apiUrl = getConfig().apiUrl;
    const response = await axios.get<StudentFileListResponse>(
      `${apiUrl}/files/topic/${courseId}/${topicId}`,
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }

  /**
   * Track file download for analytics
   */
  async trackDownload(fileId: string): Promise<void> {
    const apiUrl = getConfig().apiUrl;
    try {
      await axios.post(
        `${apiUrl}/files/download/${fileId}`,
        {},
        { headers: this.getAuthHeaders() }
      );
    } catch (error) {
      // Don't fail if tracking fails
      console.warn('Failed to track download:', error);
    }
  }
}

export const courseResourcesService = new CourseResourcesService();
